/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"

function PreviewPill() {
  return (
    <div className="badge badge--red">
      <FaIcon name="fa-times"/>
      {I18n.t("js.embedded_quiz.study_summary.preview")}
    </div>
  )
}

export default PreviewPill
